import { render, staticRenderFns } from "./StatementRefund.vue?vue&type=template&id=5bae0254&"
import script from "./StatementRefund.vue?vue&type=script&lang=js&"
export * from "./StatementRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports